module.exports = __webpack_public_path__ + "img/usd_fixed.a052dbf2.jpg";